import { gql } from '@apollo/client';

export const DELETE_OFFICE_MUTATION = gql`
	mutation RemoveOffice($id: Int!) {
		removeOffice(id: $id) {
      id
		}
	}
`;